import { FetchState, FetchStateKey, HackMap } from "@/shared/types";
import _ from "lodash";

export const fetchStateKeyMatch = (a: Partial<FetchStateKey>, b: Partial<FetchStateKey>) => {
  // supress null value errors
  if (!a && !b) {
    return true;
  }
  a = a || {username: "", partnerId: 0, accountId: 0};
  b = b || {username: "", partnerId: 0, accountId: 0};

  a = {
    username: a.username || "",
    partnerId: a.partnerId || 0,
    accountId: a.accountId || 0
  };

  b = {
    username: b.username || "",
    partnerId: b.partnerId || 0,
    accountId: b.accountId || 0
  };

  return _.isEqual(a, b);
};

export interface MutationNames {
  invalidateLoadedState: string;
  setLoading: string;
  setValueLoaded: string;
  resetState: string;
}

export interface FetchStateKeyedMixin {
  fetchKey: FetchStateKey|null;
  fetchState: FetchState;
}

export type FetchKeyedResource<T> = FetchStateKeyedMixin & T;

export interface FetchKeyedCollectionMixin<T> {
  fetchKey: FetchStateKey|null;
  fetchStates: HackMap<FetchState>;
  items: HackMap<T>;
}